export function contactUsToggler() {
    const togglerBtns = $("[data-toggler-btn]");
    const forms = $("[data-form]");
    togglerBtns.each(function () {
        $(this).on("click", function (e) {
            e.preventDefault();
            const formName = $(this).data("form-name");
            togglerBtns.removeClass("white transparent");
            $(this).addClass("white").siblings().addClass("transparent");
            forms.hide();
            console.log($(`[data-form="${formName}"]`));
            $(`[data-form="${formName}"]`).show();
        });
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/contactUs.js